module.exports = __webpack_public_path__ + "img/121.5.c98ba3be.png";